import { render, staticRenderFns } from "./zhijian.vue?vue&type=template&id=916ede54"
import script from "./zhijian.vue?vue&type=script&lang=js"
export * from "./zhijian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports